import styled from 'styled-components'

export const Header = styled.header`
    background: #fff;
    grid-area: header;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 10px;
    min-height: 40px;

    border-bottom: 1px solid #d3d3d3;
`

export const Leftside = styled.div`
    display: flex;
    align-items: center;

    > button {
        cursor: pointer;
    }

    > nav {
        margin-left: 14px;
        align-items: center;
        display: flex;

        > span,
        a {
            font-family: 'Inter', sans-serif;
            font-size: 13px;
            font-weight: 700;
            color: #0d233b;

            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        > a {
            font-weight: 500;
            color: #4c83ee;
            &:hover {
                color: #566583;
            }
        }
    }
`

export const UserActions = styled.div`
    display: flex;
    align-items: center;

    > div {
        padding: 0 14px;
    }

    & .messages,
    & .notifications,
    & .cart {
        /* border-right: 1px solid #d3d3d3; */
        height: 24px;
        /* display: flex; */
        /* align-items: center; */
        /* justify-content: center; */
    }

    & .messages,
    & .notifications {
        display: none;
        @media (min-width: 500px) {
            display: flex;
        }
    }

    & .cart {
        /* padding-right: 18px; */
    }
`
export const Separator = styled.span`
    width: 1px;
    height: 27px;
    background: #d3d3d3;
`
